var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 416,
    height: 286,
    viewBox: "0 0 416 286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5705",
    "data-name": "Group 5705",
    transform: "translate(-1468.806 -246.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5161",
    "data-name": "Group 5161",
    transform: "translate(1863.528 334.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5160",
    "data-name": "Group 5160",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15056",
    "data-name": "Path 15056",
    d: "M2135.424,399.131c-.845-3.682-3.6-4.994-5.749-4.816a3.349,3.349,0,0,1-6.424-1.812c-1.74-1.276-4.773-1.6-7.418,1.1-5.52,5.628,5.472,18.086,5.472,18.086S2137.188,406.815,2135.424,399.131Z",
    transform: "translate(-2114.282 -391.549)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5163",
    "data-name": "Group 5163",
    transform: "translate(1635.573 257.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5162",
    "data-name": "Group 5162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15057",
    "data-name": "Path 15057",
    d: "M1772.78,269.872c-2.7-4.932-7.174-5.7-10.181-4.575a10.374,10.374,0,0,0-4.967,4.575,10.376,10.376,0,0,0-4.968-4.575c-3.008-1.124-7.482-.357-10.181,4.575-5.633,10.293,15.148,23.694,15.148,23.694S1778.412,280.165,1772.78,269.872Z",
    transform: "translate(-1741.515 -264.844)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5165",
    "data-name": "Group 5165",
    transform: "translate(1676.254 246.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5164",
    "data-name": "Group 5164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15058",
    "data-name": "Path 15058",
    d: "M1827.81,249.436c-1.707-3.119-4.536-3.6-6.438-2.893a3.151,3.151,0,0,1-6.282,0c-1.9-.711-4.732-.226-6.438,2.893-3.561,6.509,9.579,14.982,9.579,14.982S1831.372,255.945,1827.81,249.436Z",
    transform: "translate(-1808.04 -246.256)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5178",
    "data-name": "Group 5178",
    transform: "translate(1730.914 249.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5172",
    "data-name": "Group 5172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5167",
    "data-name": "Group 5167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5166",
    "data-name": "Group 5166"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 26.991,
    cy: 26.991,
    r: 26.991,
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5169",
    "data-name": "Group 5169",
    transform: "translate(36.387 24.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5168",
    "data-name": "Group 5168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15059",
    "data-name": "Path 15059",
    d: "M1957.348,293.364c-.826,1.785-.4,3.739.953,4.364s3.117-.314,3.943-2.1.4-3.739-.953-4.364S1958.173,291.579,1957.348,293.364Z",
    transform: "translate(-1956.927 -291.071)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5171",
    "data-name": "Group 5171",
    transform: "translate(16.027 14.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5170",
    "data-name": "Group 5170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15060",
    "data-name": "Path 15060",
    d: "M1924.052,277.959c-.826,1.785-.4,3.739.953,4.364s3.117-.314,3.943-2.1.4-3.738-.953-4.364S1924.878,276.174,1924.052,277.959Z",
    transform: "translate(-1923.631 -275.666)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5177",
    "data-name": "Group 5177",
    transform: "translate(17.293 23.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5174",
    "data-name": "Group 5174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5173",
    "data-name": "Group 5173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15061",
    "data-name": "Path 15061",
    d: "M1926.669,290.275c-2.295,4.961-.372,10.734,4.3,12.893s10.313-.111,12.608-5.072Z",
    transform: "translate(-1925.7 -290.275)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5176",
    "data-name": "Group 5176",
    transform: "translate(1.477 8.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15062",
    "data-name": "Path 15062",
    d: "M1928.115,305.474a6.192,6.192,0,0,1,8.807,4.074A9.563,9.563,0,0,1,1928.115,305.474Z",
    transform: "translate(-1928.115 -304.843)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5280",
    "data-name": "Group 5280",
    transform: "translate(1522.923 253.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5224",
    "data-name": "Group 5224",
    transform: "translate(38.704 9.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5181",
    "data-name": "Group 5181",
    transform: "translate(0 0.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5180",
    "data-name": "Group 5180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4802",
    "data-name": "Rectangle 4802",
    width: 9.834,
    height: 26.429,
    transform: "matrix(0.955, -0.296, 0.296, 0.955, 0, 2.91)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5184",
    "data-name": "Group 5184",
    transform: "translate(2.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5183",
    "data-name": "Group 5183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5182",
    "data-name": "Group 5182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4803",
    "data-name": "Rectangle 4803",
    width: 9.834,
    height: 26.429,
    transform: "translate(0 2.91) rotate(-17.214)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5187",
    "data-name": "Group 5187",
    transform: "translate(7.152 5.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5186",
    "data-name": "Group 5186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15063",
    "data-name": "Path 15063",
    d: "M1632.395,285.291a2.219,2.219,0,1,0,1.463-2.776A2.219,2.219,0,0,0,1632.395,285.291Z",
    transform: "translate(-1632.295 -282.415)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5191",
    "data-name": "Group 5191",
    transform: "translate(1.188 7.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5190",
    "data-name": "Group 5190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15064",
    "data-name": "Path 15064",
    d: "M1622.546,286.035a13.684,13.684,0,0,1,3.657,2.858,13.714,13.714,0,0,1-3.657-2.858Z",
    transform: "translate(-1622.542 -286.026)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5195",
    "data-name": "Group 5195",
    transform: "translate(2.053 10.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5194",
    "data-name": "Group 5194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5193",
    "data-name": "Group 5193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5192",
    "data-name": "Group 5192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15065",
    "data-name": "Path 15065",
    d: "M1623.961,290.6a13.693,13.693,0,0,1,3.657,2.857,13.7,13.7,0,0,1-3.657-2.857Z",
    transform: "translate(-1623.957 -290.594)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5199",
    "data-name": "Group 5199",
    transform: "translate(2.919 13.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5198",
    "data-name": "Group 5198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5197",
    "data-name": "Group 5197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5196",
    "data-name": "Group 5196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15066",
    "data-name": "Path 15066",
    d: "M1625.376,295.169a13.681,13.681,0,0,1,3.657,2.858,13.717,13.717,0,0,1-3.657-2.858Z",
    transform: "translate(-1625.372 -295.161)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5203",
    "data-name": "Group 5203",
    transform: "translate(3.784 15.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5202",
    "data-name": "Group 5202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5201",
    "data-name": "Group 5201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5200",
    "data-name": "Group 5200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15067",
    "data-name": "Path 15067",
    d: "M1626.791,299.737a13.679,13.679,0,0,1,3.657,2.858,13.686,13.686,0,0,1-3.657-2.858Z",
    transform: "translate(-1626.787 -299.728)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5207",
    "data-name": "Group 5207",
    transform: "translate(4.649 18.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5206",
    "data-name": "Group 5206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5205",
    "data-name": "Group 5205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5204",
    "data-name": "Group 5204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15068",
    "data-name": "Path 15068",
    d: "M1628.206,304.3a13.682,13.682,0,0,1,3.657,2.858,13.715,13.715,0,0,1-3.657-2.858Z",
    transform: "translate(-1628.202 -304.296)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5211",
    "data-name": "Group 5211",
    transform: "translate(5.514 21.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5209",
    "data-name": "Group 5209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5208",
    "data-name": "Group 5208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15069",
    "data-name": "Path 15069",
    d: "M1629.621,308.872a13.688,13.688,0,0,1,3.657,2.858,13.683,13.683,0,0,1-3.657-2.858Z",
    transform: "translate(-1629.617 -308.863)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5215",
    "data-name": "Group 5215",
    transform: "translate(6.38 24.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5213",
    "data-name": "Group 5213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    "data-name": "Group 5212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15070",
    "data-name": "Path 15070",
    d: "M1631.036,313.44a13.7,13.7,0,0,1,3.657,2.857,13.7,13.7,0,0,1-3.657-2.857Z",
    transform: "translate(-1631.032 -313.431)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219",
    transform: "translate(0.451 5.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    "data-name": "Group 5218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5216",
    "data-name": "Group 5216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15071",
    "data-name": "Path 15071",
    d: "M1621.34,281.994A13.7,13.7,0,0,1,1625,284.85a13.7,13.7,0,0,1-3.657-2.857Z",
    transform: "translate(-1621.336 -281.985)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5223",
    "data-name": "Group 5223",
    transform: "translate(0.992 3.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15072",
    "data-name": "Path 15072",
    d: "M1622.229,279.323c.067-.086.607.223,1.2.689s1.028.915.96,1-.606-.222-1.2-.689S1622.161,279.409,1622.229,279.323Z",
    transform: "translate(-1622.222 -279.308)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5279",
    "data-name": "Group 5279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5227",
    "data-name": "Group 5227",
    transform: "translate(0.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5226",
    "data-name": "Group 5226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5225",
    "data-name": "Group 5225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15073",
    "data-name": "Path 15073",
    d: "M1598.485,296.25l-7.421-22.151s-5.266.574-11.784-4.806c-4.313-3.561-4.7-8.629-5.87-10.416-.715-1.093-3.468.024-4.663.552a5.086,5.086,0,0,0-3.109,3.864c-.445,3.91,4.222,11.492,4.222,11.492s1.442,1.392-.906,2.119l-8.376,2.6a4.778,4.778,0,0,0-2.649,1.988,3.546,3.546,0,0,0-.308,3.341c1.239,3.109,3.358,4.016,3.566,4.686s-.35,2.131.918,3.852,1.636,1.424,1.922,2.346a15.77,15.77,0,0,0,2.21,4.463,7.154,7.154,0,0,0,1.908,1.707s.6,3.18,2.068,4.6c1.926,1.86,7.918,1.635,9.876-.118.916-.82,5.533-3.553,7.7-4.867S1595.883,295.861,1598.485,296.25Z",
    transform: "translate(-1557.339 -258.415)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5230",
    "data-name": "Group 5230",
    transform: "translate(3.529 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5229",
    "data-name": "Group 5229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5228",
    "data-name": "Group 5228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15074",
    "data-name": "Path 15074",
    d: "M1603.792,295.576l-6.99-22.561s-5.266.574-11.784-4.806a39.372,39.372,0,0,1-7.923-8.547,2.683,2.683,0,0,0-3.309-1.02,4.086,4.086,0,0,0-2.641,3.508c-.444,3.911,4.451,11.552,4.451,11.552s1.443,1.392-.906,2.119l-8.376,2.6a4.773,4.773,0,0,0-2.648,1.987,3.547,3.547,0,0,0-.309,3.341c1.24,3.109,3.358,4.016,3.566,4.686s-.351,2.131.918,3.852,1.636,1.424,1.922,2.346a15.755,15.755,0,0,0,2.21,4.463,7.159,7.159,0,0,0,1.907,1.707,12.16,12.16,0,0,0,2.069,4.6c1.384,1.5,5.193,1.333,6.367.969s9.042-4.64,11.208-5.955S1601.189,295.188,1603.792,295.576Z",
    transform: "translate(-1563.076 -258.422)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5234",
    "data-name": "Group 5234",
    transform: "translate(10.362 12.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5233",
    "data-name": "Group 5233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5232",
    "data-name": "Group 5232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5231",
    "data-name": "Group 5231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15075",
    "data-name": "Path 15075",
    d: "M1574.253,278.21a41.844,41.844,0,0,1,5.4,2.846,16.538,16.538,0,0,1-5.4-2.846Z",
    transform: "translate(-1574.251 -278.201)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5238",
    "data-name": "Group 5238",
    transform: "translate(8.976 9.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5237",
    "data-name": "Group 5237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5236",
    "data-name": "Group 5236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5235",
    "data-name": "Group 5235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15076",
    "data-name": "Path 15076",
    d: "M1571.987,273.5a18.484,18.484,0,0,1,2.555,1.08,9.236,9.236,0,0,1,2.471,1.287,10.738,10.738,0,0,1-2.631-.925A6.83,6.83,0,0,1,1571.987,273.5Z",
    transform: "translate(-1571.984 -273.495)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5242",
    "data-name": "Group 5242",
    transform: "translate(8.362 6.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5241",
    "data-name": "Group 5241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5240",
    "data-name": "Group 5240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5239",
    "data-name": "Group 5239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15077",
    "data-name": "Path 15077",
    d: "M1570.983,268.937a16.407,16.407,0,0,1,2.105.785,5.114,5.114,0,0,1,2.044,1,9.506,9.506,0,0,1-2.177-.629A4.216,4.216,0,0,1,1570.983,268.937Z",
    transform: "translate(-1570.98 -268.924)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5246",
    "data-name": "Group 5246",
    transform: "translate(8.582 3.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5245",
    "data-name": "Group 5245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5244",
    "data-name": "Group 5244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5243",
    "data-name": "Group 5243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15078",
    "data-name": "Path 15078",
    d: "M1571.343,264.751a3.654,3.654,0,0,1,1.6.476c.843.363,1.49.739,1.447.84a3.654,3.654,0,0,1-1.6-.476C1571.947,265.228,1571.3,264.852,1571.343,264.751Z",
    transform: "translate(-1571.341 -264.726)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5250",
    "data-name": "Group 5250",
    transform: "translate(9.87 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5249",
    "data-name": "Group 5249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5248",
    "data-name": "Group 5248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5247",
    "data-name": "Group 5247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15079",
    "data-name": "Path 15079",
    d: "M1573.447,261.678c.026-.106.471-.069.995.083s.919.36.884.464-.48.066-.995-.083S1573.421,261.784,1573.447,261.678Z",
    transform: "translate(-1573.446 -261.618)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5254",
    "data-name": "Group 5254",
    transform: "translate(12.248 15.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5253",
    "data-name": "Group 5253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5252",
    "data-name": "Group 5252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5251",
    "data-name": "Group 5251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15080",
    "data-name": "Path 15080",
    d: "M1577.338,284.373a4.076,4.076,0,0,1,1.692.516c.892.386,1.578.78,1.535.88a4.078,4.078,0,0,1-1.692-.517C1577.982,284.867,1577.294,284.473,1577.338,284.373Z",
    transform: "translate(-1577.336 -284.35)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5258",
    "data-name": "Group 5258",
    transform: "translate(1.053 27.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5257",
    "data-name": "Group 5257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5256",
    "data-name": "Group 5256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5255",
    "data-name": "Group 5255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15081",
    "data-name": "Path 15081",
    d: "M1559.029,304.147a26.857,26.857,0,0,1,6.221,1.926,26.861,26.861,0,0,1-6.221-1.926Z",
    transform: "translate(-1559.028 -304.129)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5262",
    "data-name": "Group 5262",
    transform: "translate(0 24.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5261",
    "data-name": "Group 5261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5259",
    "data-name": "Group 5259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15082",
    "data-name": "Path 15082",
    d: "M1557.306,297.819a9.6,9.6,0,0,1,3.708,1.156,9.63,9.63,0,0,1-3.708-1.156Z",
    transform: "translate(-1557.305 -297.788)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266",
    transform: "translate(4.031 33.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15083",
    "data-name": "Path 15083",
    d: "M1563.9,312.442a9.665,9.665,0,0,1,4.589,1.411,31.016,31.016,0,0,1-4.589-1.411Z",
    transform: "translate(-1563.897 -312.406)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5270",
    "data-name": "Group 5270",
    transform: "translate(6.6 36.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5269",
    "data-name": "Group 5269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5268",
    "data-name": "Group 5268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5267",
    "data-name": "Group 5267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15084",
    "data-name": "Path 15084",
    d: "M1568.1,318.939a14.4,14.4,0,0,1,4.485,1.6,14.447,14.447,0,0,1-4.485-1.6Z",
    transform: "translate(-1568.098 -318.918)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5274",
    "data-name": "Group 5274",
    transform: "translate(9.171 41.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5272",
    "data-name": "Group 5272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5271",
    "data-name": "Group 5271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15085",
    "data-name": "Path 15085",
    d: "M1572.3,326.857a46.434,46.434,0,0,1,5.257,1.754,12.421,12.421,0,0,1-5.257-1.754Z",
    transform: "translate(-1572.303 -326.842)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5278",
    "data-name": "Group 5278",
    transform: "translate(11.586 45.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5277",
    "data-name": "Group 5277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5276",
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15086",
    "data-name": "Path 15086",
    d: "M1576.254,333.388a63.43,63.43,0,0,1,6.133,2.046,16.828,16.828,0,0,1-6.133-2.046Z",
    transform: "translate(-1576.253 -333.375)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5285",
    "data-name": "Group 5285",
    transform: "translate(1474.391 350.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5281",
    "data-name": "Group 5281",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4804",
    "data-name": "Rectangle 4804",
    width: 96.815,
    height: 34.877,
    rx: 7.306,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5282",
    "data-name": "Group 5282",
    transform: "translate(10.146 10.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 6.365,
    cy: 6.365,
    r: 6.365,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5283",
    "data-name": "Group 5283",
    transform: "translate(27.302 14.299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4805",
    "data-name": "Rectangle 4805",
    width: 50.351,
    height: 2.959,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5284",
    "data-name": "Group 5284",
    transform: "translate(27.302 19.522)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4806",
    "data-name": "Rectangle 4806",
    width: 20.318,
    height: 2.959,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5290",
    "data-name": "Group 5290",
    transform: "translate(1783.557 394.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5286",
    "data-name": "Group 5286"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4807",
    "data-name": "Rectangle 4807",
    width: 96.815,
    height: 34.877,
    rx: 7.306,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5287",
    "data-name": "Group 5287",
    transform: "translate(7.657 8.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 6.365,
    cy: 6.365,
    r: 6.365,
    transform: "translate(0 10.475) rotate(-55.37)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5288",
    "data-name": "Group 5288",
    transform: "translate(27.302 14.299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4808",
    "data-name": "Rectangle 4808",
    width: 50.351,
    height: 2.959,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5289",
    "data-name": "Group 5289",
    transform: "translate(27.302 19.522)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4809",
    "data-name": "Rectangle 4809",
    width: 20.318,
    height: 2.959,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5392",
    "data-name": "Group 5392",
    transform: "translate(1486.606 293.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5336",
    "data-name": "Group 5336",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5293",
    "data-name": "Group 5293",
    transform: "translate(1.27 0.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5292",
    "data-name": "Group 5292",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5291",
    "data-name": "Group 5291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4810",
    "data-name": "Rectangle 4810",
    width: 14.777,
    height: 5.498,
    transform: "matrix(0.519, -0.855, 0.855, 0.519, 0, 12.631)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5296",
    "data-name": "Group 5296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5295",
    "data-name": "Group 5295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5294",
    "data-name": "Group 5294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4811",
    "data-name": "Rectangle 4811",
    width: 14.777,
    height: 5.498,
    transform: "translate(0 12.631) rotate(-58.736)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5299",
    "data-name": "Group 5299",
    transform: "translate(2.844 9.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5298",
    "data-name": "Group 5298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5297",
    "data-name": "Group 5297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15087",
    "data-name": "Path 15087",
    d: "M1504.867,341.674a1.24,1.24,0,1,0-1.7.417A1.241,1.241,0,0,0,1504.867,341.674Z",
    transform: "translate(-1502.566 -339.789)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5303",
    "data-name": "Group 5303",
    transform: "translate(6.899 11.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5302",
    "data-name": "Group 5302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5301",
    "data-name": "Group 5301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5300",
    "data-name": "Group 5300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15088",
    "data-name": "Path 15088",
    d: "M1509.413,345.774a7.666,7.666,0,1,1,.031-1.3A3.891,3.891,0,0,1,1509.413,345.774Z",
    transform: "translate(-1509.197 -343.184)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5307",
    "data-name": "Group 5307",
    transform: "translate(7.748 10.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5306",
    "data-name": "Group 5306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5305",
    "data-name": "Group 5305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5304",
    "data-name": "Group 5304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15089",
    "data-name": "Path 15089",
    d: "M1510.8,343.489a7.665,7.665,0,1,1,.031-1.3A3.893,3.893,0,0,1,1510.8,343.489Z",
    transform: "translate(-1510.585 -340.899)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5311",
    "data-name": "Group 5311",
    transform: "translate(8.596 8.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5310",
    "data-name": "Group 5310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5309",
    "data-name": "Group 5309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5308",
    "data-name": "Group 5308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15090",
    "data-name": "Path 15090",
    d: "M1512.188,341.2a7.662,7.662,0,1,1,.031-1.3A3.9,3.9,0,0,1,1512.188,341.2Z",
    transform: "translate(-1511.972 -338.613)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5315",
    "data-name": "Group 5315",
    transform: "translate(9.444 7.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5314",
    "data-name": "Group 5314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5313",
    "data-name": "Group 5313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5312",
    "data-name": "Group 5312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15091",
    "data-name": "Path 15091",
    d: "M1513.575,338.918a7.655,7.655,0,1,1,.031-1.3A3.906,3.906,0,0,1,1513.575,338.918Z",
    transform: "translate(-1513.359 -336.328)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5319",
    "data-name": "Group 5319",
    transform: "translate(10.293 6.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5318",
    "data-name": "Group 5318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5317",
    "data-name": "Group 5317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5316",
    "data-name": "Group 5316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15092",
    "data-name": "Path 15092",
    d: "M1514.963,336.633a7.668,7.668,0,1,1,.031-1.3A3.891,3.891,0,0,1,1514.963,336.633Z",
    transform: "translate(-1514.747 -334.043)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5323",
    "data-name": "Group 5323",
    transform: "translate(11.141 4.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5322",
    "data-name": "Group 5322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5321",
    "data-name": "Group 5321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5320",
    "data-name": "Group 5320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15093",
    "data-name": "Path 15093",
    d: "M1516.35,334.348a7.643,7.643,0,1,1,.031-1.3A3.9,3.9,0,0,1,1516.35,334.348Z",
    transform: "translate(-1516.134 -331.758)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5327",
    "data-name": "Group 5327",
    transform: "translate(11.99 3.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5326",
    "data-name": "Group 5326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5325",
    "data-name": "Group 5325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5324",
    "data-name": "Group 5324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15094",
    "data-name": "Path 15094",
    d: "M1517.738,332.063a7.665,7.665,0,1,1,.031-1.3A3.891,3.891,0,0,1,1517.738,332.063Z",
    transform: "translate(-1517.522 -329.473)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5331",
    "data-name": "Group 5331",
    transform: "translate(6.138 12.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5330",
    "data-name": "Group 5330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5329",
    "data-name": "Group 5329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5328",
    "data-name": "Group 5328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15095",
    "data-name": "Path 15095",
    d: "M1508.168,347.776a7.658,7.658,0,1,1,.031-1.3A3.912,3.912,0,0,1,1508.168,347.776Z",
    transform: "translate(-1507.952 -345.186)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5335",
    "data-name": "Group 5335",
    transform: "translate(5.302 14.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5334",
    "data-name": "Group 5334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5333",
    "data-name": "Group 5333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5332",
    "data-name": "Group 5332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15096",
    "data-name": "Path 15096",
    d: "M1506.753,349.064c-.061,0-.131-.336-.158-.759s0-.77.063-.774.132.336.158.759S1506.814,349.06,1506.753,349.064Z",
    transform: "translate(-1506.585 -347.531)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5391",
    "data-name": "Group 5391",
    transform: "translate(7.133 5.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5339",
    "data-name": "Group 5339",
    transform: "translate(1.756 1.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5337",
    "data-name": "Group 5337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15097",
    "data-name": "Path 15097",
    d: "M1518.973,333.856l-6.521,11.316s2.192,1.992,2.355,6.714c.108,3.125-1.87,5.165-2.184,6.318-.192.7,1.3,1.443,1.959,1.747a2.843,2.843,0,0,0,2.77-.13c1.8-1.263,3.246-6.027,3.246-6.027s.048-1.12,1.223-.406l4.191,2.544a2.671,2.671,0,0,0,1.814.372,1.985,1.985,0,0,0,1.513-1.109c.842-1.671.436-2.894.64-3.23s1.022-.643,1.272-1.812-.01-1.212.27-1.674a8.806,8.806,0,0,0,1.049-2.579,4,4,0,0,0,.007-1.431,5.847,5.847,0,0,0,1.159-2.57c.064-1.5-2.251-3.92-3.71-4.09-.682-.08-3.538-1-4.891-1.419S1519.774,335.089,1518.973,333.856Z",
    transform: "translate(-1512.451 -333.856)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5342",
    "data-name": "Group 5342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15098",
    "data-name": "Path 15098",
    d: "M1516.434,332.159l-6.854,11.288s2.192,1.992,2.356,6.714a22.013,22.013,0,0,1-.642,6.484,1.5,1.5,0,0,0,.8,1.764,2.285,2.285,0,0,0,2.447-.2c1.8-1.263,3.186-6.145,3.186-6.145s.048-1.119,1.223-.406l4.19,2.544a2.671,2.671,0,0,0,1.814.372,1.985,1.985,0,0,0,1.513-1.109c.842-1.671.436-2.894.64-3.23s1.022-.643,1.272-1.812-.01-1.212.27-1.674a8.824,8.824,0,0,0,1.049-2.579,4,4,0,0,0,.007-1.432,6.8,6.8,0,0,0,1.159-2.57c.116-1.136-1.367-2.667-1.954-3.024s-5.293-2.065-6.646-2.485S1517.235,333.392,1516.434,332.159Z",
    transform: "translate(-1509.58 -332.159)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5346",
    "data-name": "Group 5346",
    transform: "translate(8.102 20.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5344",
    "data-name": "Group 5344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5343",
    "data-name": "Group 5343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15099",
    "data-name": "Path 15099",
    d: "M1523.652,368.427a23.293,23.293,0,0,1-.811-3.317,9.249,9.249,0,0,1,.811,3.317Z",
    transform: "translate(-1522.829 -365.109)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5350",
    "data-name": "Group 5350",
    transform: "translate(7.348 22.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5349",
    "data-name": "Group 5349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5348",
    "data-name": "Group 5348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5347",
    "data-name": "Group 5347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15100",
    "data-name": "Path 15100",
    d: "M1522.482,371.333a10.3,10.3,0,0,1-.5-1.469,5.192,5.192,0,0,1-.377-1.512,6,6,0,0,1,.588,1.444A3.82,3.82,0,0,1,1522.482,371.333Z",
    transform: "translate(-1521.597 -368.352)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5354",
    "data-name": "Group 5354",
    transform: "translate(6.487 24.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5353",
    "data-name": "Group 5353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5352",
    "data-name": "Group 5352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5351",
    "data-name": "Group 5351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15101",
    "data-name": "Path 15101",
    d: "M1520.994,373.815a9.182,9.182,0,0,1-.452-1.172,2.869,2.869,0,0,1-.338-1.227,5.325,5.325,0,0,1,.544,1.144A2.356,2.356,0,0,1,1520.994,373.815Z",
    transform: "translate(-1520.189 -371.416)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5358",
    "data-name": "Group 5358",
    transform: "translate(5.543 25.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5357",
    "data-name": "Group 5357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5356",
    "data-name": "Group 5356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5355",
    "data-name": "Group 5355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15102",
    "data-name": "Path 15102",
    d: "M1519.244,375.617c-.058.019-.236-.361-.4-.848a2.034,2.034,0,0,1-.185-.917c.058-.019.235.36.4.848A2.047,2.047,0,0,1,1519.244,375.617Z",
    transform: "translate(-1518.645 -373.852)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5362",
    "data-name": "Group 5362",
    transform: "translate(4.395 26.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5361",
    "data-name": "Group 5361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5360",
    "data-name": "Group 5360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5359",
    "data-name": "Group 5359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15103",
    "data-name": "Path 15103",
    d: "M1517.257,376.358c-.054.029-.2-.171-.334-.447s-.19-.518-.133-.542.206.177.333.447S1517.31,376.329,1517.257,376.358Z",
    transform: "translate(-1516.768 -375.367)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5366",
    "data-name": "Group 5366",
    transform: "translate(9.176 19.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5365",
    "data-name": "Group 5365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5364",
    "data-name": "Group 5364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5363",
    "data-name": "Group 5363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15104",
    "data-name": "Path 15104",
    d: "M1525.215,365.769a4.4,4.4,0,1,1-.2-.969A2.277,2.277,0,0,1,1525.215,365.769Z",
    transform: "translate(-1524.585 -363.9)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370",
    transform: "translate(17.509 18.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5369",
    "data-name": "Group 5369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5367",
    "data-name": "Group 5367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15105",
    "data-name": "Path 15105",
    d: "M1539.72,365.185a15.009,15.009,0,0,1-1.5-3.318,15.042,15.042,0,0,1,1.5,3.318Z",
    transform: "translate(-1538.214 -361.866)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5374",
    "data-name": "Group 5374",
    transform: "translate(16.886 21.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5373",
    "data-name": "Group 5373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5372",
    "data-name": "Group 5372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5371",
    "data-name": "Group 5371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15106",
    "data-name": "Path 15106",
    d: "M1538.1,369.1a5.383,5.383,0,1,1-.344-1.035A2.757,2.757,0,0,1,1538.1,369.1Z",
    transform: "translate(-1537.194 -367.116)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5378",
    "data-name": "Group 5378",
    transform: "translate(18.916 15.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5377",
    "data-name": "Group 5377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5376",
    "data-name": "Group 5376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5375",
    "data-name": "Group 5375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15107",
    "data-name": "Path 15107",
    d: "M1541.636,360.623a5.4,5.4,0,0,1-1.111-2.444,17.244,17.244,0,0,1,1.111,2.444Z",
    transform: "translate(-1540.514 -358.179)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5382",
    "data-name": "Group 5382",
    transform: "translate(19.744 13.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5381",
    "data-name": "Group 5381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5380",
    "data-name": "Group 5380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5379",
    "data-name": "Group 5379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15108",
    "data-name": "Path 15108",
    d: "M1542.871,356.442a8.061,8.061,0,1,1-.393-1.277A4.087,4.087,0,0,1,1542.871,356.442Z",
    transform: "translate(-1541.869 -353.97)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386",
    transform: "translate(20.599 10.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5385",
    "data-name": "Group 5385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5384",
    "data-name": "Group 5384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5383",
    "data-name": "Group 5383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15109",
    "data-name": "Path 15109",
    d: "M1544.486,351.507a25.927,25.927,0,0,1-1.214-2.851,6.944,6.944,0,0,1,1.214,2.851Z",
    transform: "translate(-1543.266 -348.655)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5390",
    "data-name": "Group 5390",
    transform: "translate(21.174 7.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5389",
    "data-name": "Group 5389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5387",
    "data-name": "Group 5387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15110",
    "data-name": "Path 15110",
    d: "M1545.628,347.133a35.754,35.754,0,0,1-1.416-3.325,9.384,9.384,0,0,1,1.416,3.325Z",
    transform: "translate(-1544.206 -343.806)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394",
    transform: "translate(1856.428 271.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15111",
    "data-name": "Path 15111",
    d: "M2115.751,288.951a3.468,3.468,0,0,0-4.259-1.914,2.085,2.085,0,0,1-4.156,0,3.467,3.467,0,0,0-4.259,1.914c-2.356,4.306,6.336,9.911,6.336,9.911S2118.107,293.257,2115.751,288.951Z",
    transform: "translate(-2102.673 -286.848)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395",
    transform: "translate(1483.726 465.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15112",
    "data-name": "Path 15112",
    d: "M1505.974,605.78l4.077,4.278a2.092,2.092,0,0,0,1.821.608l6.058-.895a1.979,1.979,0,0,1,2.072,2.95l-3.065,5.156a1.946,1.946,0,0,0-.081,1.869l2.615,5.248a2.076,2.076,0,0,1-2.324,2.878l-5.973-1.092a2.182,2.182,0,0,0-1.871.547l-4.442,4.139a2.077,2.077,0,0,1-3.509-1.172l-.626-5.831a1.947,1.947,0,0,0-1.076-1.531l-5.36-2.691a1.979,1.979,0,0,1,.156-3.6l5.585-2.511a2.089,2.089,0,0,0,1.207-1.493l1.129-5.8A2.139,2.139,0,0,1,1505.974,605.78Z",
    transform: "translate(-1493.205 -605.146)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402",
    transform: "translate(1847.536 445.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5397",
    "data-name": "Group 5397",
    transform: "translate(7.863 17.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15113",
    "data-name": "Path 15113",
    d: "M2100.989,602.014l7.435,10.63a2.006,2.006,0,0,0,3.324-.056l7.2-11.056Z",
    transform: "translate(-2100.989 -601.533)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5399",
    "data-name": "Group 5399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4812",
    "data-name": "Rectangle 4812",
    d: "M11.563,0H21A11.564,11.564,0,0,1,32.563,11.564v.554A11.563,11.563,0,0,1,21,23.681H11.564A11.564,11.564,0,0,1,0,12.117v-.554A11.563,11.563,0,0,1,11.563,0Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5401",
    "data-name": "Group 5401",
    transform: "translate(10.565 7.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5400",
    "data-name": "Group 5400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15114",
    "data-name": "Path 15114",
    d: "M2117.5,587.78a3.206,3.206,0,0,0-3.938-1.77,1.928,1.928,0,0,1-3.843,0,3.206,3.206,0,0,0-3.938,1.77c-2.178,3.981,5.859,9.164,5.859,9.164S2119.68,591.761,2117.5,587.78Z",
    transform: "translate(-2105.409 -585.835)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5450",
    "data-name": "Group 5450",
    transform: "translate(1522.798 323.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5433",
    "data-name": "Group 5433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5432",
    "data-name": "Group 5432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5431",
    "data-name": "Group 5431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5430",
    "data-name": "Group 5430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5410",
    "data-name": "Group 5410",
    transform: "translate(11.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5409",
    "data-name": "Group 5409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5405",
    "data-name": "Group 5405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15115",
    "data-name": "Path 15115",
    d: "M1825.023,566.9H1589.478c-7.786,0-14.1-6.568-14.1-14.671V384a10.5,10.5,0,0,1,10.284-10.7H1829.4a9.922,9.922,0,0,1,9.718,10.113V552.232C1839.121,560.335,1832.81,566.9,1825.023,566.9Z",
    transform: "translate(-1575.381 -373.296)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5422",
    "data-name": "Group 5422",
    transform: "translate(0 179.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5421",
    "data-name": "Group 5421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5420",
    "data-name": "Group 5420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5419",
    "data-name": "Group 5419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5418",
    "data-name": "Group 5418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413",
    transform: "translate(0.148 0.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5412",
    "data-name": "Group 5412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5411",
    "data-name": "Group 5411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15116",
    "data-name": "Path 15116",
    d: "M1831.838,683.966H1570.973c-7.527,0-13.629-6.35-13.629-14.183v-2.211a.536.536,0,0,1,.525-.547h284.692a.536.536,0,0,1,.525.547v4.687A11.485,11.485,0,0,1,1831.838,683.966Z",
    transform: "translate(-1557.344 -667.026)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5417",
    "data-name": "Group 5417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5416",
    "data-name": "Group 5416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5415",
    "data-name": "Group 5415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5414",
    "data-name": "Group 5414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    "data-name": "Path 15117",
    d: "M1831.743,683.87s.13-.012.385-.028a8.633,8.633,0,0,0,1.138-.107,10.391,10.391,0,0,0,4.2-1.54,10.852,10.852,0,0,0,2.544-2.165,11.7,11.7,0,0,0,2.115-3.482,12.487,12.487,0,0,0,.819-4.722q0-1.3,0-2.68,0-.691,0-1.4c0-.241.021-.477-.15-.625-.151-.167-.386-.128-.624-.131l-63.533.048-209.606.044H1557.8a.38.38,0,0,0-.391.294,3.112,3.112,0,0,0-.013.454v.988c-.012.662.016,1.313.053,1.961a13.991,13.991,0,0,0,.8,3.789,15.489,15.489,0,0,0,.756,1.774,15.289,15.289,0,0,0,1.006,1.63,13.256,13.256,0,0,0,9.332,5.651,36.959,36.959,0,0,0,3.7.1h21.992l55.653.009,94.234.032,63.529.048,17.272.028,4.492.015c1.012,0,1.53.015,1.53.015s-.518.01-1.53.016l-4.492.015-17.272.029-63.529.048-94.234.032-55.653.009h-21.992c-1.234,0-2.475.026-3.729-.1a13.548,13.548,0,0,1-9.533-5.772,15.545,15.545,0,0,1-1.028-1.665,15.792,15.792,0,0,1-.773-1.812,14.3,14.3,0,0,1-.819-3.871c-.038-.665-.065-1.328-.054-1.984v-.988a2.9,2.9,0,0,1,.023-.532.69.69,0,0,1,.383-.462.678.678,0,0,1,.289-.057h11.224l209.606.045,63.533.048.355,0a.567.567,0,0,1,.345.161.6.6,0,0,1,.176.344,3.535,3.535,0,0,1,.008.366q0,.711,0,1.4,0,1.381,0,2.68a12.582,12.582,0,0,1-.84,4.756,11.781,11.781,0,0,1-2.141,3.5,10.875,10.875,0,0,1-2.568,2.167,10.315,10.315,0,0,1-4.224,1.518,8.058,8.058,0,0,1-1.141.092C1831.873,683.869,1831.743,683.87,1831.743,683.87Z",
    transform: "translate(-1557.102 -666.778)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    "data-name": "Group 5429",
    transform: "translate(117.048 179.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5428",
    "data-name": "Group 5428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5425",
    "data-name": "Group 5425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5424",
    "data-name": "Group 5424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5423",
    "data-name": "Group 5423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    "data-name": "Path 15118",
    d: "M1748.515,666.493l3.546,6.261h49.894l3.293-6.261Z",
    transform: "translate(-1748.515 -666.493)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5444",
    "data-name": "Group 5444",
    transform: "translate(24.11 14.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5435",
    "data-name": "Group 5435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5434",
    "data-name": "Group 5434"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4813",
    "data-name": "Rectangle 4813",
    width: 241.776,
    height: 158.591,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5437",
    "data-name": "Group 5437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5436",
    "data-name": "Group 5436"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4814",
    "data-name": "Rectangle 4814",
    width: 241.776,
    height: 15.899,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(5.243 4.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    "data-name": "Path 15119",
    d: "M1609.764,407.761a2.332,2.332,0,1,1-2.33-2.419A2.376,2.376,0,0,1,1609.764,407.761Z",
    transform: "translate(-1605.104 -405.342)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5441",
    "data-name": "Group 5441",
    transform: "translate(12.046 4.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15120",
    "data-name": "Path 15120",
    d: "M1620.89,407.761a2.332,2.332,0,1,1-2.33-2.419A2.375,2.375,0,0,1,1620.89,407.761Z",
    transform: "translate(-1616.23 -405.342)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5443",
    "data-name": "Group 5443",
    transform: "translate(18.85 4.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5442",
    "data-name": "Group 5442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    "data-name": "Path 15121",
    d: "M1632.017,407.761a2.332,2.332,0,1,1-2.33-2.419A2.376,2.376,0,0,1,1632.017,407.761Z",
    transform: "translate(-1627.357 -405.342)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5445",
    "data-name": "Group 5445",
    transform: "translate(36.389 48.434)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 15.865,
    cy: 15.865,
    r: 15.865,
    transform: "translate(0 22.437) rotate(-45)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5446",
    "data-name": "Group 5446",
    transform: "translate(38.698 95.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4815",
    "data-name": "Rectangle 4815",
    width: 58.071,
    height: 18.105,
    rx: 4.673,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5447",
    "data-name": "Group 5447",
    transform: "translate(38.698 119.114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4816",
    "data-name": "Rectangle 4816",
    width: 58.071,
    height: 18.105,
    rx: 4.673,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5448",
    "data-name": "Group 5448",
    transform: "translate(38.698 142.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4817",
    "data-name": "Rectangle 4817",
    width: 58.071,
    height: 18.105,
    rx: 4.673,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5449",
    "data-name": "Group 5449",
    transform: "translate(103.339 54.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4818",
    "data-name": "Rectangle 4818",
    width: 143.91,
    height: 119.211,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451",
    transform: "translate(1580.282 323.487)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4819",
    "data-name": "Rectangle 4819",
    d: "M8.019,0H169.6a8.02,8.02,0,0,1,8.02,8.02V162.806a8.02,8.02,0,0,1-8.02,8.02H8.019A8.019,8.019,0,0,1,0,162.806V8.019A8.019,8.019,0,0,1,8.019,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "translate(1588.239 281.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5482",
    "data-name": "Group 5482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5452",
    "data-name": "Group 5452",
    transform: "translate(0.159 0.132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4820",
    "data-name": "Rectangle 4820",
    width: 207.139,
    height: 161.825,
    rx: 7.617,
    transform: "translate(0 207.139) rotate(-90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5453",
    "data-name": "Group 5453",
    transform: "translate(0.159 0.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4821",
    "data-name": "Rectangle 4821",
    d: "M7.472,0H154.866a6.959,6.959,0,0,1,6.959,6.959V18.353a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.472A7.472,7.472,0,0,1,7.472,0Z",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5455",
    "data-name": "Group 5455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15122",
    "data-name": "Path 15122",
    d: "M1826.091,309.248s-.013-.16-.032-.473a5.058,5.058,0,0,0-.359-1.354,4.732,4.732,0,0,0-1.4-1.809,4.681,4.681,0,0,0-2.968-.989l-21.266.03-78.216.05-25.917.01-13.787,0-7.09,0h-5.4a7.265,7.265,0,0,0-1.775.127,4.517,4.517,0,0,0-3.418,3.69,13.088,13.088,0,0,0-.061,1.823q0,3.7,0,7.465,0,7.524,0,15.282,0,15.513.007,31.9c0,43.661.008,91.661.013,142.044a4.628,4.628,0,0,0,.558,2.187,4.538,4.538,0,0,0,1.548,1.636,4.4,4.4,0,0,0,2.141.681c.766.026,1.562.007,2.341.013h27.9l36.243,0,68.515.009,16.167,0c.659-.009,1.341.02,1.979-.019a4.4,4.4,0,0,0,1.824-.559,4.556,4.556,0,0,0,2.206-2.987,9.07,9.07,0,0,0,.1-1.927q0-.981,0-1.957,0-1.953,0-3.893,0-15.514.008-30.092c.007-19.417.013-37.5.02-54.014.021-33.021.039-59.742.051-78.211.013-9.232.023-16.4.03-21.264.007-2.429.012-4.281.016-5.53s.016-1.884.016-1.884.011.638.016,1.884.009,3.1.016,5.53c.007,4.864.017,12.032.03,21.264.012,18.469.03,45.19.05,78.211.006,16.511.013,34.6.02,54.014q0,14.562.008,30.092,0,1.94,0,3.893,0,.977,0,1.957a9.345,9.345,0,0,1-.108,1.986,4.842,4.842,0,0,1-2.344,3.177,4.682,4.682,0,0,1-1.94.6c-.685.041-1.333.012-2,.021l-16.167,0-68.515.009-36.243,0h-27.9c-.786-.006-1.558.013-2.359-.013a4.716,4.716,0,0,1-2.294-.73,4.853,4.853,0,0,1-1.657-1.751,4.947,4.947,0,0,1-.6-2.34c0-50.383.008-98.383.012-142.044q0-16.373.007-31.9,0-7.756,0-15.282,0-3.763,0-7.465a13.388,13.388,0,0,1,.065-1.864,4.786,4.786,0,0,1,3.621-3.906,7.548,7.548,0,0,1,1.836-.133h5.4l7.09,0,13.787,0,25.917.01,78.216.051,21.266.03a4.7,4.7,0,0,1,4.4,2.85,4.965,4.965,0,0,1,.345,1.365C1826.089,309.088,1826.091,309.248,1826.091,309.248Z",
    transform: "translate(-1664.107 -304.458)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5458",
    "data-name": "Group 5458",
    transform: "translate(57.782 26.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    "data-name": "Path 15123",
    d: "M1758.6,355.171l.816-1.847a5.158,5.158,0,0,0,2.481.687c.72,0,.977-.15.977-.408,0-.945-4.156-.183-4.156-2.986,0-1.4,1.171-2.535,3.5-2.535a5.971,5.971,0,0,1,2.835.656l-.762,1.836a4.638,4.638,0,0,0-2.094-.558c-.741,0-.977.215-.977.473,0,.9,4.156.15,4.156,2.921,0,1.375-1.171,2.534-3.5,2.534A6.735,6.735,0,0,1,1758.6,355.171Z",
    transform: "translate(-1758.601 -348.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15124",
    "data-name": "Path 15124",
    d: "M1770.809,352.5v-4.134h2.535v4.059c0,1.15.44,1.579,1.149,1.579s1.149-.429,1.149-1.579v-4.059h2.492V352.5c0,2.255-1.353,3.555-3.662,3.555S1770.809,354.755,1770.809,352.5Z",
    transform: "translate(-1763.344 -348.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15125",
    "data-name": "Path 15125",
    d: "M1787.91,353.992h-.687v1.891h-2.535v-7.518h3.62c2.094,0,3.426,1.1,3.426,2.835a2.518,2.518,0,0,1-1.417,2.363l1.578,2.32h-2.707Zm.237-3.673h-.924v1.761h.924c.7,0,1.031-.333,1.031-.881S1788.844,350.319,1788.147,350.319Z",
    transform: "translate(-1768.736 -348.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15126",
    "data-name": "Path 15126",
    d: "M1805.291,348.365l-3.179,7.518h-2.492l-3.179-7.518h2.728l1.794,4.392,1.836-4.392Z",
    transform: "translate(-1773.302 -348.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15127",
    "data-name": "Path 15127",
    d: "M1817.572,353.971v1.911h-6.251v-7.518h6.111v1.912h-3.619v.881h3.179v1.825h-3.179v.989Z",
    transform: "translate(-1779.083 -348.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15128",
    "data-name": "Path 15128",
    d: "M1826.952,353.155v2.728h-2.535v-2.76l-2.835-4.757h2.675l1.536,2.6,1.547-2.6h2.448Z",
    transform: "translate(-1783.069 -348.193)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5464",
    "data-name": "Group 5464",
    transform: "translate(27.471 77.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5460",
    "data-name": "Group 5460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4822",
    "data-name": "Rectangle 4822",
    width: 19.863,
    height: 19.863,
    rx: 3.863,
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5463",
    "data-name": "Group 5463",
    transform: "translate(4.082 5.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5462",
    "data-name": "Group 5462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5461",
    "data-name": "Group 5461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15129",
    "data-name": "Path 15129",
    d: "M1721.272,448.433l-5.564-4.3,1.5-1.942,3.731,2.883,5.306-6.106,1.852,1.61Z",
    transform: "translate(-1715.708 -438.969)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5465",
    "data-name": "Group 5465",
    transform: "translate(57.93 53.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4823",
    "data-name": "Rectangle 4823",
    width: 70.767,
    height: 4.732,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5468",
    "data-name": "Group 5468",
    transform: "translate(27.471 46.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5467",
    "data-name": "Group 5467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5466",
    "data-name": "Group 5466"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4824",
    "data-name": "Rectangle 4824",
    width: 19.863,
    height: 19.863,
    rx: 3.863,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5469",
    "data-name": "Group 5469",
    transform: "translate(57.93 85.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4825",
    "data-name": "Rectangle 4825",
    width: 56.654,
    height: 4.732,
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5472",
    "data-name": "Group 5472",
    transform: "translate(27.471 109.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5471",
    "data-name": "Group 5471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5470",
    "data-name": "Group 5470"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4826",
    "data-name": "Rectangle 4826",
    width: 19.863,
    height: 19.863,
    rx: 3.863,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5473",
    "data-name": "Group 5473",
    transform: "translate(57.93 117.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4827",
    "data-name": "Rectangle 4827",
    width: 62.659,
    height: 4.732,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5476",
    "data-name": "Group 5476",
    transform: "translate(27.471 141.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5475",
    "data-name": "Group 5475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5474",
    "data-name": "Group 5474"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4828",
    "data-name": "Rectangle 4828",
    width: 19.863,
    height: 19.863,
    rx: 3.863,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5479",
    "data-name": "Group 5479",
    transform: "translate(27.471 171.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5478",
    "data-name": "Group 5478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5477",
    "data-name": "Group 5477"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4829",
    "data-name": "Rectangle 4829",
    width: 19.863,
    height: 19.863,
    rx: 3.863,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5480",
    "data-name": "Group 5480",
    transform: "translate(57.93 149.722)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4830",
    "data-name": "Rectangle 4830",
    width: 38.175,
    height: 4.732,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5481",
    "data-name": "Group 5481",
    transform: "translate(57.93 179.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4831",
    "data-name": "Rectangle 4831",
    width: 70.767,
    height: 4.732,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5483",
    "data-name": "Group 5483",
    transform: "translate(6.588 5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15130",
    "data-name": "Path 15130",
    d: "M1680.7,317.027a2.912,2.912,0,1,1-2.912-2.912A2.912,2.912,0,0,1,1680.7,317.027Z",
    transform: "translate(-1674.881 -314.115)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5484",
    "data-name": "Group 5484",
    transform: "translate(14.45 5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15131",
    "data-name": "Path 15131",
    d: "M1693.561,317.027a2.912,2.912,0,1,1-2.911-2.912A2.911,2.911,0,0,1,1693.561,317.027Z",
    transform: "translate(-1687.738 -314.115)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5485",
    "data-name": "Group 5485",
    transform: "translate(22.312 5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15132",
    "data-name": "Path 15132",
    d: "M1706.418,317.027a2.912,2.912,0,1,1-2.911-2.912A2.912,2.912,0,0,1,1706.418,317.027Z",
    transform: "translate(-1700.595 -314.115)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488",
    transform: "translate(1676.257 408.516)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5487",
    "data-name": "Group 5487"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4832",
    "data-name": "Rectangle 4832",
    width: 108.763,
    height: 33.475,
    rx: 3.855
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5499",
    "data-name": "Group 5499",
    transform: "translate(1671.999 402.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5492",
    "data-name": "Group 5492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(0.159 0.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4833",
    "data-name": "Rectangle 4833",
    width: 108.763,
    height: 33.475,
    rx: 3.855,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15133",
    "data-name": "Path 15133",
    d: "M1907.642,535.981a3.186,3.186,0,0,0,.708-.125,2.35,2.35,0,0,0,1.465-1.409,4.035,4.035,0,0,0,.145-1.535q0-.865-.008-1.89c0-1.367-.009-2.942-.015-4.715-.007-3.55-.016-7.89-.027-12.928q-.005-3.78-.012-8.072a3.7,3.7,0,0,0-.085-1.044,2.193,2.193,0,0,0-.5-.907,2.336,2.336,0,0,0-1.933-.742l-4.643.005-99.137.046a2.2,2.2,0,0,0-2.2,2.115q0,1.8,0,3.591,0,3.585,0,7.121,0,7.072,0,13.924,0,1.712,0,3.408a4.176,4.176,0,0,0,.157,1.613,2.221,2.221,0,0,0,1.035,1.141,2.1,2.1,0,0,0,.745.23c.252.027.541.015.818.018h4.978l12.884,0,44.57.034,30.047.051,8.169.03,2.125.016c.479,0,.724.016.724.016s-.245.011-.724.017l-2.125.016-8.169.03-30.047.05-44.57.034-12.884.005h-4.978c-.28,0-.55.011-.854-.02a2.421,2.421,0,0,1-.85-.262,2.53,2.53,0,0,1-1.18-1.3,2.418,2.418,0,0,1-.177-.878l0-.85q0-1.7,0-3.408,0-6.846,0-13.924,0-3.535,0-7.121,0-1.8,0-3.6a2.516,2.516,0,0,1,2.519-2.422l99.137.047,4.643.005a2.547,2.547,0,0,1,2.088.817,2.4,2.4,0,0,1,.543.992,3.863,3.863,0,0,1,.089,1.1q-.007,4.285-.012,8.072c-.01,5.037-.02,9.378-.027,12.928-.006,1.773-.01,3.349-.015,4.715q0,1.024-.008,1.89a4.08,4.08,0,0,1-.164,1.558,2.37,2.37,0,0,1-1.515,1.417A1.95,1.95,0,0,1,1907.642,535.981Z",
    transform: "translate(-1801.077 -502.348)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5498",
    "data-name": "Group 5498",
    transform: "translate(7.066 9.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5493",
    "data-name": "Group 5493",
    transform: "translate(39.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15134",
    "data-name": "Path 15134",
    d: "M1884.163,518.2l-1.535,3.11a1.184,1.184,0,0,1-.892.648l-3.432.5a1.185,1.185,0,0,0-.657,2.022l2.483,2.421a1.184,1.184,0,0,1,.341,1.049l-.586,3.418a1.185,1.185,0,0,0,1.719,1.25l3.07-1.614a1.185,1.185,0,0,1,1.1,0l3.07,1.614a1.185,1.185,0,0,0,1.719-1.25l-.586-3.418a1.185,1.185,0,0,1,.341-1.049l2.484-2.421a1.185,1.185,0,0,0-.657-2.022l-3.432-.5a1.184,1.184,0,0,1-.892-.648l-1.535-3.11A1.185,1.185,0,0,0,1884.163,518.2Z",
    transform: "translate(-1877.288 -517.538)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "translate(59.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15135",
    "data-name": "Path 15135",
    d: "M1916.491,518.2l-1.535,3.11a1.184,1.184,0,0,1-.893.648l-3.432.5a1.185,1.185,0,0,0-.657,2.022l2.484,2.421a1.184,1.184,0,0,1,.341,1.049l-.586,3.418a1.185,1.185,0,0,0,1.719,1.25L1917,531a1.185,1.185,0,0,1,1.1,0l3.07,1.614a1.185,1.185,0,0,0,1.719-1.25l-.586-3.418a1.186,1.186,0,0,1,.341-1.049l2.483-2.421a1.185,1.185,0,0,0-.657-2.022l-3.432-.5a1.183,1.183,0,0,1-.892-.648l-1.535-3.11A1.185,1.185,0,0,0,1916.491,518.2Z",
    transform: "translate(-1909.615 -517.538)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495",
    transform: "translate(79.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15136",
    "data-name": "Path 15136",
    d: "M1948.818,518.2l-1.535,3.11a1.183,1.183,0,0,1-.892.648l-3.432.5a1.185,1.185,0,0,0-.657,2.022l2.483,2.421a1.184,1.184,0,0,1,.341,1.049l-.586,3.418a1.185,1.185,0,0,0,1.719,1.25l3.07-1.614a1.185,1.185,0,0,1,1.1,0l3.07,1.614a1.186,1.186,0,0,0,1.72-1.25l-.587-3.418a1.184,1.184,0,0,1,.341-1.049l2.484-2.421a1.185,1.185,0,0,0-.657-2.022l-3.432-.5a1.184,1.184,0,0,1-.893-.648l-1.535-3.11A1.185,1.185,0,0,0,1948.818,518.2Z",
    transform: "translate(-1941.943 -517.538)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496",
    transform: "translate(19.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15137",
    "data-name": "Path 15137",
    d: "M1851.836,518.2l-1.535,3.11a1.183,1.183,0,0,1-.892.648l-3.432.5a1.185,1.185,0,0,0-.657,2.022l2.483,2.421a1.185,1.185,0,0,1,.341,1.049l-.586,3.418a1.185,1.185,0,0,0,1.72,1.25l3.07-1.614a1.184,1.184,0,0,1,1.1,0l3.07,1.614a1.185,1.185,0,0,0,1.719-1.25l-.586-3.418a1.183,1.183,0,0,1,.341-1.049l2.483-2.421a1.185,1.185,0,0,0-.657-2.022l-3.432-.5a1.184,1.184,0,0,1-.892-.648l-1.535-3.11A1.185,1.185,0,0,0,1851.836,518.2Z",
    transform: "translate(-1844.96 -517.538)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5497",
    "data-name": "Group 5497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15138",
    "data-name": "Path 15138",
    d: "M1819.509,518.2l-1.536,3.11a1.183,1.183,0,0,1-.892.648l-3.432.5a1.185,1.185,0,0,0-.657,2.022l2.484,2.421a1.185,1.185,0,0,1,.341,1.049l-.586,3.418a1.185,1.185,0,0,0,1.719,1.25l3.07-1.614a1.183,1.183,0,0,1,1.1,0l3.07,1.614a1.185,1.185,0,0,0,1.719-1.25l-.586-3.418a1.184,1.184,0,0,1,.341-1.049l2.483-2.421a1.185,1.185,0,0,0-.657-2.022l-3.432-.5a1.184,1.184,0,0,1-.892-.648l-1.535-3.11A1.185,1.185,0,0,0,1819.509,518.2Z",
    transform: "translate(-1812.633 -517.538)",
    fill: "#962cc6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5510",
    "data-name": "Group 5510",
    transform: "translate(1468.806 399.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5504",
    "data-name": "Group 5504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5503",
    "data-name": "Group 5503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5500",
    "data-name": "Group 5500",
    transform: "translate(0.145 0.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15139",
    "data-name": "Path 15139",
    d: "M1551.282,497.31h-71.025a11.214,11.214,0,0,0-11.214,11.214v26.639a11.214,11.214,0,0,0,11.214,11.214h41.008a21.159,21.159,0,0,0,9.271,9.374,41.033,41.033,0,0,0,10.29,3.667,1.526,1.526,0,0,0,1.574-2.408,25.443,25.443,0,0,1-4.768-10.633h13.65a11.214,11.214,0,0,0,11.214-11.214V508.524A11.214,11.214,0,0,0,1551.282,497.31Z",
    transform: "translate(-1469.043 -497.31)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5502",
    "data-name": "Group 5502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5501",
    "data-name": "Group 5501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15140",
    "data-name": "Path 15140",
    d: "M1551.19,497.223s.119,0,.353.007a9.718,9.718,0,0,1,1.042.067,11.111,11.111,0,0,1,3.872,1.194,11.473,11.473,0,0,1,4.631,4.541,11.321,11.321,0,0,1,1.284,3.944,16.977,16.977,0,0,1,.11,2.286q0,1.175,0,2.417c0,6.623.045,14.647.01,23.847a10.693,10.693,0,0,1-.678,3.455,10.967,10.967,0,0,1-1.774,3.165,11.345,11.345,0,0,1-6.311,3.978,16.412,16.412,0,0,1-3.914.3l-4,0-8.277,0,.137-.166a25.554,25.554,0,0,0,3.39,8.615c.422.674.878,1.328,1.366,1.97a1.66,1.66,0,0,1,.32,1.257,1.71,1.71,0,0,1-.691,1.1,1.643,1.643,0,0,1-1.279.279c-.416-.085-.806-.187-1.211-.286-.8-.2-1.606-.419-2.407-.659a32.024,32.024,0,0,1-9.257-4.269,20.329,20.329,0,0,1-6.876-7.919l.141.091-29.244,0H1480.8c-.608.012-1.232-.027-1.849-.067l-.917-.14c-.305-.045-.6-.145-.9-.215a11.161,11.161,0,0,1-5.978-4.032,10.708,10.708,0,0,1-1.717-3.175,11.194,11.194,0,0,1-.632-3.523c0-9.419.009-18.505.013-27.16a11.471,11.471,0,0,1,.545-3.208,12.123,12.123,0,0,1,1.415-2.885,12.545,12.545,0,0,1,2.134-2.344,12.059,12.059,0,0,1,2.66-1.642,11.081,11.081,0,0,1,2.961-.843,19.689,19.689,0,0,1,3.018-.128l5.868,0,21.407.02,31,.051,8.428.029,2.192.016c.493.005.747.016.747.016s-.253.011-.747.017l-2.192.015-8.428.03-31,.051-21.407.02-5.868,0a19.369,19.369,0,0,0-2.979.129,10.817,10.817,0,0,0-2.887.826,11.778,11.778,0,0,0-2.592,1.6,12.265,12.265,0,0,0-2.079,2.288,11.831,11.831,0,0,0-1.376,2.813,11.188,11.188,0,0,0-.527,3.127c0,8.651,0,17.732.005,27.146a10.882,10.882,0,0,0,.616,3.426,10.408,10.408,0,0,0,1.671,3.086,10.856,10.856,0,0,0,5.813,3.918c.292.067.577.164.874.208l.891.136c.6.038,1.2.076,1.815.065h11.131l29.244,0h.1l.042.09a20.039,20.039,0,0,0,6.769,7.8,31.748,31.748,0,0,0,9.167,4.234q1.194.358,2.394.657c.4.1.8.2,1.192.283a1.346,1.346,0,0,0,1.053-.227,1.417,1.417,0,0,0,.573-.913,1.364,1.364,0,0,0-.264-1.033c-.49-.646-.953-1.312-1.378-1.993a25.83,25.83,0,0,1-3.418-8.715l-.032-.166h.169l8.277.005,4,0a16.157,16.157,0,0,0,3.857-.287,11.092,11.092,0,0,0,6.178-3.88,10.736,10.736,0,0,0,1.742-3.095,10.457,10.457,0,0,0,.671-3.382c.021-9.189.04-17.217.055-23.839-.021-1.653.073-3.231-.095-4.684a11.208,11.208,0,0,0-1.25-3.9,11.42,11.42,0,0,0-4.561-4.525,11.257,11.257,0,0,0-3.837-1.227c-.453-.076-.8-.062-1.036-.089S1551.19,497.223,1551.19,497.223Z",
    transform: "translate(-1468.806 -497.085)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5506",
    "data-name": "Group 5506",
    transform: "translate(6.924 14.284)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 6.598,
    cy: 6.598,
    r: 6.598,
    transform: "translate(0 9.33) rotate(-45)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5507",
    "data-name": "Group 5507",
    transform: "translate(27.438 17.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4834",
    "data-name": "Rectangle 4834",
    width: 52.189,
    height: 3.067,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5508",
    "data-name": "Group 5508",
    transform: "translate(27.438 24.396)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4835",
    "data-name": "Rectangle 4835",
    width: 52.189,
    height: 3.067,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5509",
    "data-name": "Group 5509",
    transform: "translate(27.438 31.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4836",
    "data-name": "Rectangle 4836",
    width: 21.06,
    height: 3.067,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5704",
    "data-name": "Group 5704",
    transform: "translate(1780.247 266.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5584",
    "data-name": "Group 5584",
    transform: "translate(17.133 243.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524",
    transform: "translate(0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5523",
    "data-name": "Group 5523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5522",
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5520",
    "data-name": "Group 5520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5519",
    "data-name": "Group 5519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5517",
    "data-name": "Group 5517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5515",
    "data-name": "Group 5515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5513",
    "data-name": "Group 5513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5512",
    "data-name": "Group 5512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5511",
    "data-name": "Group 5511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15141",
    "data-name": "Path 15141",
    d: "M2016.125,678.733l.576,10.515s-10.495,4.117-10.577,6.07l20.428-.385-.225-16.421Z",
    transform: "translate(-2006.124 -678.513)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5538",
    "data-name": "Group 5538",
    transform: "translate(0 14.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5537",
    "data-name": "Group 5537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5529",
    "data-name": "Group 5529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5528",
    "data-name": "Group 5528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5527",
    "data-name": "Group 5527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5526",
    "data-name": "Group 5526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5525",
    "data-name": "Group 5525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15142",
    "data-name": "Path 15142",
    d: "M2026.546,704.357l-.022-1.591-19.619.924s-.9.413-.787,1.051Z",
    transform: "translate(-2006.107 -702.766)",
    fill: "#455a64"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5553",
    "data-name": "Group 5553",
    transform: "translate(10.254 10.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5552",
    "data-name": "Group 5552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5551",
    "data-name": "Group 5551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5550",
    "data-name": "Group 5550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5549",
    "data-name": "Group 5549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5548",
    "data-name": "Group 5548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5547",
    "data-name": "Group 5547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    "data-name": "Group 5545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    "data-name": "Group 5544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    "data-name": "Group 5543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    "data-name": "Group 5542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    "data-name": "Group 5541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5539",
    "data-name": "Group 5539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15143",
    "data-name": "Path 15143",
    d: "M2022.877,695.846c0,.1.5.136,1,.447s.766.726.857.684c.091-.021-.068-.615-.677-.981S2022.853,695.755,2022.877,695.846Z",
    transform: "translate(-2022.876 -695.748)",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5568",
    "data-name": "Group 5568",
    transform: "translate(8.128 11.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5567",
    "data-name": "Group 5567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5563",
    "data-name": "Group 5563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5562",
    "data-name": "Group 5562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5559",
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5558",
    "data-name": "Group 5558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    "data-name": "Group 5556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15144",
    "data-name": "Path 15144",
    d: "M2019.4,697.4c-.021.1.415.259.761.674s.453.86.552.853c.094.014.152-.571-.289-1.08S2019.4,697.3,2019.4,697.4Z",
    transform: "translate(-2019.399 -697.354)",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5583",
    "data-name": "Group 5583",
    transform: "translate(6.13 12.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5582",
    "data-name": "Group 5582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5581",
    "data-name": "Group 5581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5579",
    "data-name": "Group 5579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5578",
    "data-name": "Group 5578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5577",
    "data-name": "Group 5577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5576",
    "data-name": "Group 5576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5575",
    "data-name": "Group 5575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5574",
    "data-name": "Group 5574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5573",
    "data-name": "Group 5573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5572",
    "data-name": "Group 5572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5571",
    "data-name": "Group 5571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5570",
    "data-name": "Group 5570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5569",
    "data-name": "Group 5569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15145",
    "data-name": "Path 15145",
    d: "M2016.962,700.571c.091.02.221-.481-.046-1.022s-.737-.75-.778-.667.254.371.465.818S2016.862,700.563,2016.962,700.571Z",
    transform: "translate(-2016.131 -698.864)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653",
    transform: "translate(57.268 242.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5593",
    "data-name": "Group 5593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5592",
    "data-name": "Group 5592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5591",
    "data-name": "Group 5591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5590",
    "data-name": "Group 5590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5589",
    "data-name": "Group 5589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5588",
    "data-name": "Group 5588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5586",
    "data-name": "Group 5586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15146",
    "data-name": "Path 15146",
    d: "M2080.4,676.779l3.433,12.27,5.513,8.922a1.305,1.305,0,0,1-.5,1.841h0a1.3,1.3,0,0,1-1.195.012c-2.4-1.217-11.222-5.739-11.423-6.651-.233-1.056-4.48-12.7-4.48-12.7Z",
    transform: "translate(-2071.743 -676.779)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5602",
    "data-name": "Group 5602",
    transform: "translate(4.23 15.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5598",
    "data-name": "Group 5598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5597",
    "data-name": "Group 5597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5595",
    "data-name": "Group 5595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15147",
    "data-name": "Path 15147",
    d: "M2091.528,709.7l-12.868-7.461.157.517a1.967,1.967,0,0,0,.817,1.083c1.051.674,3.994,2.47,10.663,5.886a1.3,1.3,0,0,0,1.232-.024Z",
    transform: "translate(-2078.66 -702.242)",
    fill: "#455a64"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5612",
    "data-name": "Group 5612",
    transform: "translate(12.65 16.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5611",
    "data-name": "Group 5611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5610",
    "data-name": "Group 5610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5609",
    "data-name": "Group 5609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5607",
    "data-name": "Group 5607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5606",
    "data-name": "Group 5606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5605",
    "data-name": "Group 5605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5603",
    "data-name": "Group 5603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15148",
    "data-name": "Path 15148",
    d: "M2092.471,705.838a2.815,2.815,0,0,1,2.1-1.969c0-.033-.181-.081-.479-.034a2.081,2.081,0,0,0-1.625,1.523C2092.4,705.651,2092.438,705.837,2092.471,705.838Z",
    transform: "translate(-2092.43 -703.815)",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622",
    transform: "translate(14.041 18.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5621",
    "data-name": "Group 5621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5619",
    "data-name": "Group 5619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5618",
    "data-name": "Group 5618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5617",
    "data-name": "Group 5617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5616",
    "data-name": "Group 5616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5614",
    "data-name": "Group 5614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5613",
    "data-name": "Group 5613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15149",
    "data-name": "Path 15149",
    d: "M2094.719,708.454c.074.035.344-.481.92-.853a10.693,10.693,0,0,1,1.144-.516,1.448,1.448,0,0,0-1.3.283C2094.831,707.8,2094.646,708.44,2094.719,708.454Z",
    transform: "translate(-2094.704 -707.027)",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5632",
    "data-name": "Group 5632",
    transform: "translate(10.428 14.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5631",
    "data-name": "Group 5631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5629",
    "data-name": "Group 5629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5628",
    "data-name": "Group 5628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5627",
    "data-name": "Group 5627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5624",
    "data-name": "Group 5624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5623",
    "data-name": "Group 5623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15150",
    "data-name": "Path 15150",
    d: "M2088.805,702.981a6.713,6.713,0,0,1,3.01-2.385,3.567,3.567,0,0,0-3.01,2.385Z",
    transform: "translate(-2088.796 -700.577)",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642",
    transform: "translate(9.078 12.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5640",
    "data-name": "Group 5640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5639",
    "data-name": "Group 5639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5638",
    "data-name": "Group 5638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5637",
    "data-name": "Group 5637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15151",
    "data-name": "Path 15151",
    d: "M2086.593,697.791c.055.063.642-.424,1.509-.722s1.625-.3,1.628-.383a3.239,3.239,0,0,0-3.137,1.1Z",
    transform: "translate(-2086.589 -696.595)",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5652",
    "data-name": "Group 5652",
    transform: "translate(7.965 9.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5651",
    "data-name": "Group 5651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5650",
    "data-name": "Group 5650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5649",
    "data-name": "Group 5649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5648",
    "data-name": "Group 5648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5647",
    "data-name": "Group 5647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5645",
    "data-name": "Group 5645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5644",
    "data-name": "Group 5644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15152",
    "data-name": "Path 15152",
    d: "M2084.773,693.127a6.352,6.352,0,0,1,1.55-.793,6.425,6.425,0,0,1,1.74-.087c.012-.031-.168-.144-.5-.221a2.847,2.847,0,0,0-2.471.661C2084.846,692.919,2084.746,693.106,2084.773,693.127Z",
    transform: "translate(-2084.769 -691.966)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5689",
    "data-name": "Group 5689",
    transform: "translate(28.81 81.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5655",
    "data-name": "Group 5655",
    transform: "translate(19.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15153",
    "data-name": "Path 15153",
    d: "M2071.878,422.29a2.32,2.32,0,0,0-2.288-2.342,2.595,2.595,0,1,0-4.063-3.011,4.64,4.64,0,0,0-9.078,1.9l.024,11.326a3.014,3.014,0,0,0,5.028,1.457,2.68,2.68,0,0,0,4.4-2.763,1.813,1.813,0,0,0,2.43.6,2.941,2.941,0,0,0,1.359-2.318,8.468,8.468,0,0,0-.329-2.762A2.32,2.32,0,0,0,2071.878,422.29Z",
    transform: "translate(-2056.388 -413.41)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5657",
    "data-name": "Group 5657",
    transform: "translate(0 2.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5656",
    "data-name": "Group 5656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15154",
    "data-name": "Path 15154",
    d: "M2049.449,426.769a13,13,0,0,0-8.061-7.839,13.978,13.978,0,0,0-4.918-.649,7.224,7.224,0,0,0-4.75,1.336,12.1,12.1,0,0,0-3.94,4.536,33.876,33.876,0,0,0-2.182,5.836,11.352,11.352,0,0,0,.065,6.16l4.75,2.483a33.23,33.23,0,0,0,8.443,2.209,11.2,11.2,0,0,0,8.214-2.286C2050.139,435.908,2050.938,430.538,2049.449,426.769Z",
    transform: "translate(-2025.204 -418.272)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5659",
    "data-name": "Group 5659",
    transform: "translate(0.239 4.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5658",
    "data-name": "Group 5658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15155",
    "data-name": "Path 15155",
    d: "M2045.137,426.323l-5.852-4.809-1.817-.357c-3.946-1.247-8.057,2.225-9.1,5.407a59.464,59.464,0,0,0-2.72,10.687,7.148,7.148,0,0,0,3.8,7.488l-1.088,5.237,4.206,4.579,5.931-4.411,7.845-21.454A1.96,1.96,0,0,0,2045.137,426.323Z",
    transform: "translate(-2025.595 -420.896)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5661",
    "data-name": "Group 5661",
    transform: "translate(5.996 20.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5660",
    "data-name": "Group 5660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15156",
    "data-name": "Path 15156",
    d: "M2037.579,448.878a1.173,1.173,0,0,0-.166-.814,1.2,1.2,0,0,0-1.362-.523,1.608,1.608,0,0,0-1.042,1.251h0a1.463,1.463,0,0,0,.812.9,1.807,1.807,0,0,0,.185.066,1.315,1.315,0,0,0,.949-.064A1.169,1.169,0,0,0,2037.579,448.878Z",
    transform: "translate(-2035.009 -447.491)",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5663",
    "data-name": "Group 5663",
    transform: "translate(3.997 15.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5662",
    "data-name": "Group 5662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15157",
    "data-name": "Path 15157",
    d: "M2031.769,438.684a.715.715,0,0,0,.486.871.683.683,0,0,0,.876-.437.715.715,0,0,0-.484-.872A.685.685,0,0,0,2031.769,438.684Z",
    transform: "translate(-2031.742 -438.211)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5665",
    "data-name": "Group 5665",
    transform: "translate(3.636 11.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5664",
    "data-name": "Group 5664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15158",
    "data-name": "Path 15158",
    d: "M2031.155,433.411c.062.113.687-.138,1.432.058s1.192.711,1.3.64c.05-.03.005-.215-.187-.451a1.966,1.966,0,0,0-1.01-.624,1.888,1.888,0,0,0-1.169.067C2031.244,433.217,2031.123,433.36,2031.155,433.411Z",
    transform: "translate(-2031.15 -432.973)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5667",
    "data-name": "Group 5667",
    transform: "translate(4.727 13.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5666",
    "data-name": "Group 5666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15159",
    "data-name": "Path 15159",
    d: "M2034.714,441.646a5.164,5.164,0,0,0-1.153-.533c-.185-.069-.355-.154-.353-.292a.993.993,0,0,1,.274-.53l.94-1.3a25.816,25.816,0,0,0,2.25-3.455,25.71,25.71,0,0,0-2.524,3.266q-.48.688-.918,1.315a1.132,1.132,0,0,0-.293.72.494.494,0,0,0,.24.36,1.334,1.334,0,0,0,.311.129A5.007,5.007,0,0,0,2034.714,441.646Z",
    transform: "translate(-2032.935 -435.535)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5669",
    "data-name": "Group 5669",
    transform: "translate(3.752 28.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5668",
    "data-name": "Group 5668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M2031.665,459.846a14.2,14.2,0,0,0,7.729-.042s-2.785,3.558-8.054,1.646Z",
    transform: "translate(-2031.34 -459.804)",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5671",
    "data-name": "Group 5671",
    transform: "translate(5.673 20.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5670",
    "data-name": "Group 5670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15161",
    "data-name": "Path 15161",
    d: "M2037.372,447.3c-.119-.039-.331.769-1.174,1.161s-1.678.08-1.714.191c-.024.048.151.207.512.311a2.082,2.082,0,0,0,1.419-.114,1.81,1.81,0,0,0,.932-.987C2037.466,447.538,2037.428,447.314,2037.372,447.3Z",
    transform: "translate(-2034.482 -447.303)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5673",
    "data-name": "Group 5673",
    transform: "translate(4.706 9.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5672",
    "data-name": "Group 5672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15162",
    "data-name": "Path 15162",
    d: "M2032.9,429.385c.078.215.68.242,1.332.471.659.208,1.158.548,1.347.422.086-.063.059-.259-.124-.5a2.19,2.19,0,0,0-2.159-.72C2033.01,429.141,2032.873,429.283,2032.9,429.385Z",
    transform: "translate(-2032.9 -428.996)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5675",
    "data-name": "Group 5675",
    transform: "translate(10.456 16.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5674",
    "data-name": "Group 5674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15163",
    "data-name": "Path 15163",
    d: "M2043.713,441.737a.715.715,0,0,1-.868.491.684.684,0,0,1-.52-.829.715.715,0,0,1,.868-.492A.685.685,0,0,1,2043.713,441.737Z",
    transform: "translate(-2042.303 -440.885)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5677",
    "data-name": "Group 5677",
    transform: "translate(10.938 14.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5676",
    "data-name": "Group 5676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15164",
    "data-name": "Path 15164",
    d: "M2045.789,437.644c-.112.064-.516-.476-1.253-.7s-1.389-.014-1.441-.128c-.027-.052.108-.186.4-.287a1.968,1.968,0,0,1,1.187-.007,1.888,1.888,0,0,1,.964.665C2045.815,437.433,2045.843,437.617,2045.789,437.644Z",
    transform: "translate(-2043.092 -436.438)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5679",
    "data-name": "Group 5679",
    transform: "translate(11.171 11.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5678",
    "data-name": "Group 5678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15165",
    "data-name": "Path 15165",
    d: "M2046.248,433.525c-.2.123-.712-.221-1.393-.435-.675-.235-1.3-.268-1.377-.482-.033-.1.109-.243.41-.325a2.2,2.2,0,0,1,1.218.068,2.175,2.175,0,0,1,1.013.671C2046.309,433.266,2046.337,433.462,2046.248,433.525Z",
    transform: "translate(-2043.473 -432.226)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5681",
    "data-name": "Group 5681",
    transform: "translate(10.148 4.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5680",
    "data-name": "Group 5680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15166",
    "data-name": "Path 15166",
    d: "M2050.239,435.9l-1.224.658c-2.75-5.062-7.457-17.038-7.205-16.334a12.126,12.126,0,0,1,5.862,1.2c2.788,1.446,7.908,4.71,6.709,8.157A19.022,19.022,0,0,1,2050.239,435.9Z",
    transform: "translate(-2041.8 -420.196)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5683",
    "data-name": "Group 5683",
    transform: "translate(16.327 19.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5682",
    "data-name": "Group 5682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15167",
    "data-name": "Path 15167",
    d: "M2052.79,446.97c.106-.4.817-1.227,1.23-1.185,1.1.111,2.991.694,2.307,3.388-.935,3.682-4.442,1.984-4.422,1.877C2051.921,450.966,2052.425,448.356,2052.79,446.97Z",
    transform: "translate(-2051.905 -445.784)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5685",
    "data-name": "Group 5685",
    transform: "translate(17.678 21.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5684",
    "data-name": "Group 5684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15168",
    "data-name": "Path 15168",
    d: "M2054.121,450.867c.02-.008.053.061.149.138a.664.664,0,0,0,.478.131c.426-.044.91-.578,1.1-1.238a2.179,2.179,0,0,0,.054-.964.764.764,0,0,0-.358-.615.339.339,0,0,0-.424.079c-.075.09-.07.17-.092.171s-.064-.081,0-.226a.422.422,0,0,1,.2-.194.5.5,0,0,1,.379,0,.931.931,0,0,1,.525.741,2.254,2.254,0,0,1-.038,1.083c-.212.736-.769,1.334-1.34,1.353a.713.713,0,0,1-.562-.246C2054.106,450.958,2054.107,450.871,2054.121,450.867Z",
    transform: "translate(-2054.114 -448.112)",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5688",
    "data-name": "Group 5688",
    transform: "translate(19.158 5.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5687",
    "data-name": "Group 5687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5686",
    "data-name": "Group 5686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15169",
    "data-name": "Path 15169",
    d: "M2061.609,436.713a5.167,5.167,0,0,1,.163-.65,14.121,14.121,0,0,0,.346-1.785,13.029,13.029,0,0,0-3.7-10.949,14.106,14.106,0,0,0-1.359-1.208,5.115,5.115,0,0,1-.523-.418.547.547,0,0,1,.154.081c.1.061.242.145.417.272a11.562,11.562,0,0,1,1.413,1.169,12.675,12.675,0,0,1,3.744,11.074,11.5,11.5,0,0,1-.414,1.787c-.062.208-.128.363-.166.47A.548.548,0,0,1,2061.609,436.713Z",
    transform: "translate(-2056.534 -421.702)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5690",
    "data-name": "Group 5690",
    transform: "translate(13.848 152.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15170",
    "data-name": "Path 15170",
    d: "M2007.216,530c-.314.32-6.8,15.159-6.467,23.018s5.067,35.218,5.067,35.218l7.573,42.322h11s0-27.056-.985-34.462-2.134-11.488-2.462-16.929-.422-16.886-.75-16.433,25.374,66.312,25.374,66.312l10.813-.716s-3.918-22.6-4.739-26.89a214.639,214.639,0,0,0-6.566-24.087c-2.463-6.651-3.325-23.238-6.731-30.374a47.64,47.64,0,0,1-4.1-14.025Z",
    transform: "translate(-2000.736 -529.999)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5691",
    "data-name": "Group 5691",
    transform: "translate(1.287 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15171",
    "data-name": "Path 15171",
    d: "M2036.172,283.685l6.542,18.32a6.878,6.878,0,0,0,4.663,4.263l19.416,5.411a6.513,6.513,0,0,1,2.287,11.643l-16.112,11.4a6.407,6.407,0,0,0-2.743,5.513l.844,19.281c.239,5.461-6.166,8.739-10.84,5.546l-16.5-11.272a7.182,7.182,0,0,0-6.359-.856l-18.893,6.506c-5.352,1.842-10.662-3.013-8.987-8.216l5.915-18.371a6.406,6.406,0,0,0-1.187-6.042l-12.521-15.26a6.513,6.513,0,0,1,5.286-10.624l20.155-.083a6.881,6.881,0,0,0,5.625-2.878l11.155-15.937A7.041,7.041,0,0,1,2036.172,283.685Z",
    transform: "translate(-1980.195 -279.156)",
    fill: "#7b6bd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5692",
    "data-name": "Group 5692",
    transform: "translate(6.38 66.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15172",
    "data-name": "Path 15172",
    d: "M1990.582,404.434l1.339-2.267s-3.376-7.033-3.4-7.669,3.126-5,3.126-5l3.625-.577a.88.88,0,0,1-.561,1.14c-.851.29-1.986.583-1.986.583l-.959,1.528s1.652-.5,2.119-.617,4.531-.1,4.485.555a1.949,1.949,0,0,1-1.476,1.732,24.735,24.735,0,0,0-2.955.689s-.792.489-.225.77,3.154-.456,3.642.06-.143,1.1-.595,1.007a12.853,12.853,0,0,0-2.635.536s2.908,2.74,2.935,4.228a42.214,42.214,0,0,1-1.029,5.96Z",
    transform: "translate(-1988.524 -388.917)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5693",
    "data-name": "Group 5693",
    transform: "translate(65.003 77.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15173",
    "data-name": "Path 15173",
    d: "M2084.911,421.382s-.72-4.69-.463-5.7,4.45-4.5,4.138-4.484-2.89-1.753-2.828-2.272l.062-.52s-.38-1.3.112-1.6,2.019.514,2.019.514a4.892,4.892,0,0,1,2.588-.508c1.07.243,1.7,2.8,1.7,2.8s1.3-.633,1.048-1.645l-.554-2.262s.582-.458,1.1.362a12.939,12.939,0,0,1,.837,5.221c-.183,1.054-4.382,3.282-4.573,4.023s.894,5.488.894,5.488Z",
    transform: "translate(-2084.392 -405.576)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5703",
    "data-name": "Group 5703",
    transform: "translate(0 81.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5694",
    "data-name": "Group 5694",
    transform: "translate(16.091 29.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15174",
    "data-name": "Path 15174",
    d: "M2033.575,498.355l6.825-32.045-9.236-1.45a11.672,11.672,0,0,1-6.125,2.1c-3.286,0-4.619-3.236-4.619-3.236l-5.972-1.442s-8.326,9.055-9.5,20.083c-.3,2.86.941,9.665,1.6,12.968a10.322,10.322,0,0,1,.04,3.812l-2.186,12.386c8.289,7.941,22.451,6.8,32.024-.588.993-1.34.16-3.841-.6-5.326Z",
    transform: "translate(-2004.404 -462.284)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5695",
    "data-name": "Group 5695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15175",
    "data-name": "Path 15175",
    d: "M1986.361,413.3s-9.649,18.921-8.1,22.062c3.023,6.14,20.12,19.925,20.12,19.925l7.66-10.485-17.876-12.179,5.082-17.427Z",
    transform: "translate(-1978.09 -413.299)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5696",
    "data-name": "Group 5696",
    transform: "translate(47.539 7.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15176",
    "data-name": "Path 15176",
    d: "M2072.645,428.373l1.348,17.36-17.581,5.7-.58,15.484,23.185-10.718c2.719-1.035,4.334-5.458,4.219-9.64-.208-7.586-3.177-20.851-3.177-20.851Z",
    transform: "translate(-2055.832 -425.706)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5698",
    "data-name": "Group 5698",
    transform: "translate(18.97 31.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5697",
    "data-name": "Group 5697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15177",
    "data-name": "Path 15177",
    d: "M2015.094,465.232a101.377,101.377,0,0,1-5.979,9.67,101.708,101.708,0,0,1,5.979-9.67Z",
    transform: "translate(-2009.112 -465.231)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5700",
    "data-name": "Group 5700",
    transform: "translate(64.988 28.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5699",
    "data-name": "Group 5699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15178",
    "data-name": "Path 15178",
    d: "M2085.7,462.133a7.908,7.908,0,0,1-1.318-2.87,7.908,7.908,0,0,1,1.318,2.87Z",
    transform: "translate(-2084.367 -459.261)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5702",
    "data-name": "Group 5702",
    transform: "translate(49.209 35.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5701",
    "data-name": "Group 5701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15179",
    "data-name": "Path 15179",
    d: "M2058.9,478.268a18.154,18.154,0,0,1-.039-6.759c.092.009.007,1.519.02,3.38S2058.992,478.259,2058.9,478.268Z",
    transform: "translate(-2058.563 -471.509)",
    fill: "#263238"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.8d2c7d41602f8ebbefb94cb4018423f1.svg";
export { ForwardRef as ReactComponent };